import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  EventEmitter,
  Output,
  ChangeDetectorRef,
  OnChanges,
  ViewChild,
  QueryList,
  ElementRef,
  ViewRef,
  AfterViewInit,
  OnDestroy,
  AfterContentInit,
  ViewChildren, NgZone
} from '@angular/core';
import { FormGroup, FormArray, ReactiveFormsModule, FormsModule } from '@angular/forms';
import * as _ from 'lodash' ;
import { CommonService } from '../services/common.service';
import { TableSearchComponent } from '../table-search/table-search.component';
import * as appApiResources from '../../shared/globalcontants';
import { MatDialog } from '@angular/material/dialog';
import { ConsignmentPopupComponent } from '../../shared/consignment-popup/consignment-popup.component';
import { PopupComponent } from '../popup/popup.component';
import { CdkVirtualScrollViewport, ScrollDispatcher, CdkScrollable, CdkFixedSizeVirtualScroll, CdkVirtualForOf } from '@angular/cdk/scrolling';
import { Observable } from 'rxjs';
import { VirtualScrollerComponent } from 'ngx-virtual-scroller';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { GlobalConversionService } from '../services/GlobalMethodService/GlobalConversion-Service';
import { ActivatedRoute, Router } from '@angular/router';
import { debounce } from 'lodash';
import * as myGlobals from '../../shared/globalcontants';
import { CSharpRequestService } from 'src/app/shared/services/csharp-request.service';
import { DecimalPipe, NgClass, NgStyle } from '@angular/common';
import { CheckboxComponent } from '../component/checkbox/checkbox.component';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { IosMinusButtonDirective } from '../directives/ios-minus-button.directive';
import { NumberOnlyDirective } from '../directives/num-only.directive';
import { BlockPasteDirective } from '../directives/block-paste.directive';
import { SupplierLocationsComponent } from '../supplier-locations/supplier-locations.component';
import { AutoFocusDirective } from '../directives/auto-focus.directive';
import { FocusOnConditionDirective } from '../directives/focus-on-condition.directive';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { NoItemsComponent } from '../no-items/no-items.component';
import { IsEmpty } from '../pipes/is-empty.pipe';
import { Sort } from '../pipes/sort.pipe';
import { TrimLower } from '../pipes/trim-lower-str.pipe';
import { GetIconName } from '../pipes/get-Icon-name.pipe';
import { HighlightPipe } from '../pipes/highlight-char.pipe';
import { FilterPipe } from '../pipes/filter-pipe';
import { DecimalFormatterPipe } from '../pipes/decimal-formatter.pipe';
import { CurrencyFormatterPipe } from '../pipes/currency-formatter.pipe';


@Component({
    selector: 'app-item-list-table',
    templateUrl: './item-list-table.component.html',
    styleUrls: ['./item-list-table.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [DecimalPipe],
    imports: [NgClass, TableSearchComponent, CheckboxComponent, CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll, CdkVirtualForOf, NgStyle, MatFormField, MatLabel, MatInput, IosMinusButtonDirective, ReactiveFormsModule, NumberOnlyDirective, BlockPasteDirective, FormsModule, SupplierLocationsComponent, AutoFocusDirective, FocusOnConditionDirective, MatMenuTrigger, MatMenu, MatMenuItem, NoItemsComponent, TranslateModule, IsEmpty, Sort, TrimLower, GetIconName, HighlightPipe, FilterPipe, DecimalFormatterPipe, CurrencyFormatterPipe]
})

export class ItemListTableComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy, AfterContentInit {

  @ViewChild(TableSearchComponent) tableSearch: TableSearchComponent;  
  @ViewChild('scrollcontainer') scrollcontainer: ElementRef;
  @ViewChild('appcontainer') appcontainer: ElementRef;
  @ViewChild('apptablerow') apptablerow: ElementRef;
  @ViewChildren('container') containers: QueryList<ElementRef>;
  @ViewChildren('namelength') namelengths: QueryList<ElementRef>;
  @ViewChildren('remarksField') remarksField: QueryList<ElementRef>;
  @ViewChild(CdkVirtualScrollViewport) viewport1: CdkVirtualScrollViewport;
  @ViewChild(VirtualScrollerComponent) private virtualScroller: VirtualScrollerComponent;

  windowHeight: number;
  scrolledIndexChange: Observable<number>;
  viewCheckedFlag = false;
  currentRowData: any;
  deviceType: string;
  excludedHeaderName: string[];
  tableData: any = [];
  tableHeader: any = [];
  tableStyle: any = [];
  tableColumn: any = [];
  tableId: any;
  tableIcon: any = [];
  headerIcon: any = [];
  showIcon = false;
  showCheckBox = false;
  disableCheckBox = false;
  detailsNavigate = false;
  unreadBar = false;
  showMore = false;
  disableMore = false;
  showContentIcon = false;
  showQuantity = false;
  showAcknowledgementQty = false;
  showTotalPrice = false;
  showReason = false;
  showLocation = false;
  showSwipe = false;
  SelectedData: any = [];
  IsCheckAll = false;
  listTypeHeader = false;
  isSwipe = false;
  swipeId;
  location: any = [];
  moreOptions: any = [];
  totalPrice = this._commonService.totalPrice;
  totalPriceAttr: any = [];
  orderId: any = [];
  orderBy: string;
  sortOrder = 'desc';
  currentId: Number;
  filterData: any;
  filter = [];
  searchData = [];
  expandedIndex: number = 0;
  showSort = true;
  showFilter = true;
  noSearchData = true;
  sortByOptions: any;
  defaultSort: string;
  _duplicateElement: string;
  page = 0;
  pagePerCount: number;
  countRecords = 0;
  tempSliceArray: any = [];
  showButtons = false;
  showButtonsPreviousValue: boolean;
  rowCount = 0;
  remarksMaxLength: number;
  previlege: any;
  mathRandom: number;
  hideBackIcon = false;
  @Input() tableInputs;
  @Input() dataInput;
  @Input() datavlaue;
  @Input() highlightText;
  @Input() searchText;
  @Input() searchKey;
  @Input() filterArray;  // Filter array form the Reqisation
  @Input() duplicateElement;
  @Input() customRowClass;
  @Input() detectChange;
  @Input() getLocation;
  @Input() locationChange;
  @Input() checkOnlineStatusforClick;
  @Input() isServiceCalled: boolean;
  @Output() RowSelectEmitter: EventEmitter<any> = new EventEmitter();
  @Output() CurrentRowSelectedEmitter: EventEmitter<any> = new EventEmitter();
  @Output() InputChange: EventEmitter<any> = new EventEmitter();
  @Output() NegativeQuantity: EventEmitter<any> = new EventEmitter();
  @Output() RowClicked: EventEmitter<any> = new EventEmitter();
  @Output() IconBackClicked: EventEmitter<any> = new EventEmitter();
  @Output() MoreOptionsClicked: EventEmitter<any> = new EventEmitter();
  @Output() filterValue: EventEmitter<any> = new EventEmitter();
  @Output() ReasonChange: EventEmitter<any> = new EventEmitter();
  @Output() RemarksChange: EventEmitter<any> = new EventEmitter();
  @Output() IconRowClick: EventEmitter<any> = new EventEmitter();
  @Output() IconNextClick: EventEmitter<any> = new EventEmitter();
  @Output() sortEmit: EventEmitter<any> = new EventEmitter();
  @Output() filterEmit: EventEmitter<any> = new EventEmitter();
  @Output() totalDataBinded: EventEmitter<any> = new EventEmitter();
  @Output() checkStatusToFilter: EventEmitter<any> = new EventEmitter();
  @Output() checkStatusToSort: EventEmitter<any> = new EventEmitter();
  @Output() emitOffineforSearch: EventEmitter<any> = new EventEmitter();
  @Output() updateTableData: EventEmitter<any> = new EventEmitter();
  @Output() apiSearchemit: EventEmitter<any> = new EventEmitter();
  @Output() zeroQuantityEmit: EventEmitter<any> = new EventEmitter();
  @Output() bottomSheet: EventEmitter<any> = new EventEmitter();
  @Output() searchFilteredTableData: EventEmitter<any> = new EventEmitter();
  @Output() scrollIndexChange: EventEmitter<any> = new EventEmitter();

  isBottom = false;
  FormGrp: FormGroup;
  reasonForm: FormGroup;
  noOfLocations: number;
  searchoptionalParams: { 'placeholder': any; 'icon-place': string; 'searchParam': string[]; };
  showSearch: any;
  searchParms: any;
  originalData: any;
  showItemList: any;
  showRowTitle: any;
  showRowTitleData: any;
  hideOfflineTitle = false;
  unit: any;
  showNodata = true;
  customClass: any;
  someClass: any;
  collapsible: any;
  quantity: FormArray;
  indexArray: any = [];
  reasons: any = [];
  toolTipData: any;
  showDropshipBeside: string;
  showPriorityBeside: string;
  priorityKey: string;
  clickedLocation: any;
  resizeWidth: any;
  resizeParameters: any;
  rowTitleClass: any;
  scrollDataArray: any = [];
  customTableData: any[];
  sortData: any[];
  isCustomTableData = false;
  disableDataAppend = false;
  negativeQuantity = false;
  inventoryStatusByLocation: any = [];
  scrollTop = 0;
  public loggedInSiteId = 0;
  scrollEventEmitter: any;
  swipeDir: string = this._commonService?.swipeDir ? this._commonService?.swipeDir : 'right';
  showNoMath = false;
  showSuspend = false;
  disableDetails = true;
  showNoDataFullScreen = false;
  numbersOnly: any = false;
  numbersDotOnly: any = false;
  showHeader = false;
  input: any;
  remarkInput: any;
  scrollOffSetHeight: number;
  selectedIndex: number;
  ItemList: any = [];
  inputIndex: number;
  tableHeaderData: any = [];
  index = -1;
  toggleSelectedIndex = false;
  intial = true;
  rowHeight: number;
  selectedRowIndex: number;
  expandedHeight: number;
  focusIn = false;
  selectedqtyIndex: number;
  sortType: string;
  transTypeID: number;
  LocationId: number;
  enableSelectBatch: boolean = false;

  numberFormat = '0.0-2';
  constructor(
    private scrollDispatcher: ScrollDispatcher,
    private dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private _commonService: CommonService,
    private router: Router,
    public _eR: ElementRef,
    private _ts: TranslateService, public globalconversion : GlobalConversionService,
    private route: ActivatedRoute,
    private csharpService: CSharpRequestService,
    private _ngZone: NgZone
    ) {
    this.previlege = appApiResources.PREVILEGEKEY;
    this.numberFormat = `0.0-${CommonService.decimalvisibleLength}`;
    window['ItemListTableComponentRef'] = {
      zone: this._ngZone,
      BindBatches: (value) => this.BindBatches(value),
      component: this,
    };
  }

  /**
   * Open consignment popup for an item row and update selected batch quantity
   */
  openConsignmentPopup(data: any) {
    try {
      const Payload = {
        IngredientId: data?.inventoryId,
        LocationId: Number(this.LocationId),
        TransactionTypeId: Number(this.transTypeID)
      };

      let batchList: any[] = [];
      this.currentRowData = data;
      if(this._commonService.isonlineStatus){
        this._commonService.GetConsignmentBatches(Payload).subscribe((res: any) => {
          batchList = (res?.ConsignmentBatch?.length > 0) ? res.ConsignmentBatch : [];
          if (data?.ConsignmentBatch?.length > 0) {
            batchList = res?.ConsignmentBatch?.map(batch => {
              const existingBatch = data.ConsignmentBatch.find(b => b.ConsignmentBatchId === batch.BatchNo);

              return {
                ...batch,
                selectedQty: existingBatch ? existingBatch.SelectedQty : 0,
                invalid: false
              };
            });
          }
          this.openConsignmentDialog(batchList, data);
        }, (error) => {
          console.error('GetConsignmentBatches error', error);
        });
      } else {
        const batchListObj = {
          componentName: appApiResources.ComponentNameReferences.ItemListTableComponentRef,
          funcName: appApiResources.CSharpCallBackFunctions.BindBatches,
          Action: myGlobals.cSharpActionName.GetBatches,
          siteId: this.loggedInSiteId,
          LocationId: Number(this.LocationId),
          TransactionTypeId: Number(this.transTypeID),
          IngredientId: data?.inventoryId
        };
        this.csharpService.RequestGETCSharp(appApiResources.cSharpURLs.GetSources, batchListObj);
      }
    } catch (error) {
      console.error('open Consignment Popup error', error);
    }
  }

  BindBatches(response: any) {
    let batchList = (response?.length > 0) ? response : [];
    if (this.currentRowData?.ConsignmentBatch?.length > 0) {
      batchList = response.map(batch => {
        const existingBatch = this.currentRowData.ConsignmentBatch.find(b => b.BatchId === batch.BatchNo);

        return {
          ...batch,
          selectedQty: existingBatch ? existingBatch.selectedQty : 0,
          invalid: false
        };
      });
    }
    this.openConsignmentDialog(batchList, this.currentRowData);
  }

  clearConsignmentPopup(data: any) {
    data.ConsignmentBatch = [];
  }

  private openConsignmentDialog(batchList: any[], data: any) {
    const qtyRequired = Number(data?.Quantity ?? data?.quantity) || 0;
    const itemName = data?.itemName;
    const dialogRef = this.dialog.open(ConsignmentPopupComponent, {
      width: '700px',
      data: { batchList, qtyRequired, itemName }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result?.selectedData?.length > 0 && (result?.type === 'save')) {
        data.ConsignmentBatch = result.selectedData.map(params => ({
          BatchId: params.BatchNo,
          BatchName: params.BatchName,
          selectedQty: Number(params.selectedQty),
          BatchQOH: Number(params.CurrentQOH ?? 0),
          IngredientId: data?.inventoryId,
          LocationId: Number(this.LocationId)
        }));
      } else if (result?.type === 'save' || result?.selectedData?.length === 0) {
        data.ConsignmentBatch = [];
      }
      this.InputChange.emit(data);
      this.currentRowData = null;
    });
  }
  trackFunction(index, data) {
    return index;
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
    this.transTypeID = params['transTypeID'] || params['transTypeId'];
    this.LocationId = params['LocationId'];
    this.enableSelectBatch = [5, 6, 11].includes(parseInt(this.transTypeID?.toString(), 10));
  });
    this.excludedHeaderName = ['checked', 'quantity', 'icon', 'itemName', 'itemCode', 'qty', 'conversion', 'lotNumber', 'VarianceQTY', 'TotalValue', 'VarianceValue'];
    this.deviceType = window.localStorage.getItem('deviceType');
    this.noOfLocations = 1;
    if (window.matchMedia('screen and (max-width: 1024px)').matches) {
      this.showHeader = false;
    } else {
      this.showHeader = true;
    }
    this.scrollDispatcher.scrolled().subscribe((data: CdkScrollable) => this.onContentScrolled(data));
  }

  ngOnChanges(changes?) {
    this.viewCheckedFlag = true;
    this.filterArray = this.filterArray;
    this.filterData = this.filterArray;
    this._duplicateElement = this.duplicateElement;
    this.customRowClass = this.tableInputs.hasOwnProperty('customRowClass') ? this.tableInputs.customRowClass : {};
    this.tableData = this.tableInputs.tableData;
    if (this._commonService.fromDetailSection) {
      this.tableData = this._commonService.itemListData;
    }
    if (this.tableInputs.tableId !== 'physicalDetails') {
    this.tableData.forEach((item, index) => {
      item['itemCollapse'] = item['itemCollapse'] === null && item['itemCollapse'] === undefined ? item['itemCollapse'] : true;
      this.expand(item,index);
    });
  }

    const _this = this;
    this.tableData.forEach(element => {
      if (element.quantity ) {
        if (typeof element.quantity === 'string') {
          if (!['n_c', 'l_p', 'bins', 'lots', 'inactive_bin'].includes(element.quantity?.trim()?.toLowerCase())) {
          element.quantity = element.quantity.toString();
        }
      } else {
        if (element.quantity !== null && element.quantity !== undefined && element.quantity !== '') {
          element.quantity = element.quantity.toString();
        } else {
          element.quantity = '0';
        }
      }
      }
    });
    this._commonService.isFocusOut = true;
    this.originalData =  this.tableInputs?.tableData?.map(tableList => {
      const tableData = {...tableList};
      return tableData;
    });
    this.searchData = this.originalData;
    this.sortData = this.originalData;
    this.tableStyle = this.tableInputs.tableStyle;
    this.tableHeader = this.tableInputs.tableHeader;
    this.tableHeaderData = this.tableInputs.hasOwnProperty('tableHeaderData') ? this.tableInputs.tableHeaderData : [];
    this.tableId = this.tableInputs.tableId;
    this.showIcon = this.tableInputs.showIcon;
    this.tableIcon = this.tableInputs.hasOwnProperty('icons') ? this.tableInputs.icons : [];
    this.headerIcon = this.tableInputs.hasOwnProperty('headerIcons') ? this.tableInputs.headerIcons : [];
    this.showCheckBox = this.tableInputs.hasOwnProperty('showCheckBox') ? this.tableInputs.showCheckBox : false;
    this.detailsNavigate = this.tableInputs.hasOwnProperty('detailsNavigate') ? this.tableInputs.detailsNavigate : false;
    this.disableCheckBox = this.tableInputs.hasOwnProperty('disableCheckBox') ? this.tableInputs.disableCheckBox : false;
    this.hideBackIcon = this.tableInputs.hasOwnProperty('hideBackIcon') ? this.tableInputs.hideBackIcon : false;
    this.showMore = this.tableInputs.hasOwnProperty('showMore') ? this.tableInputs.showMore : false;
    this.disableMore = this.tableInputs.hasOwnProperty('disableMore') ? this.tableInputs.disableMore : false;
    this.showContentIcon = this.tableInputs.hasOwnProperty('showContentIcon') ? this.tableInputs.showContentIcon : false;
    this.showQuantity = this.tableInputs.hasOwnProperty('showQuantity') ? this.tableInputs.showQuantity : false;
    this.showAcknowledgementQty = this.tableInputs.hasOwnProperty('showAcknowledgementQty') ? this.tableInputs.showAcknowledgementQty : false;
    this.showSearch = this.tableInputs.hasOwnProperty('showSearch') ? this.tableInputs.showSearch : false;
    this.showItemList = this.tableInputs.hasOwnProperty('showItemList') ? this.tableInputs.showItemList : false;
    this.showRowTitle = this.tableInputs.hasOwnProperty('showRowTitle') ? this.tableInputs.showRowTitle : false;
    this.showRowTitleData = this.tableInputs.hasOwnProperty('showRowTitleData') ? this.tableInputs.showRowTitleData : false;
    this.hideOfflineTitle = this.tableInputs.hasOwnProperty('hideOfflineTitle') ? this.tableInputs.hideOfflineTitle : false;
    this.moreOptions = this.tableInputs.hasOwnProperty('moreOptions') ? this.tableInputs.moreOptions : [];
    this.searchParms = this.tableInputs.hasOwnProperty('searchParms') ? this.tableInputs.searchParms : [];
    this.listTypeHeader = this.tableInputs.hasOwnProperty('listTypeHeader') ? this.tableInputs.listTypeHeader : false;
    this.customClass = this.tableInputs.hasOwnProperty('customClass') ? this.tableInputs.customClass : '';
    this.collapsible = this.tableInputs.hasOwnProperty('collapsible') ? this.tableInputs.collapsible : false;
    this.totalPriceAttr = this.tableInputs.hasOwnProperty('totalPriceAttr') ? this.tableInputs.totalPriceAttr : [];
    this.showTotalPrice = this.tableInputs.hasOwnProperty('showTotalPrice') ? this.tableInputs.showTotalPrice : false;
    this.showSwipe = this.tableInputs.hasOwnProperty('showSwipe') ? this.tableInputs.showSwipe : false;
    this.unit = this.tableInputs.hasOwnProperty('unit') ? this.tableInputs.unit : '';
    this.orderBy = this.tableInputs.hasOwnProperty('orderId') ? this.tableInputs.orderId : this.orderBy ? this.orderBy : '';
    this.sortOrder = this.tableInputs.hasOwnProperty('sortOrder') ? this.tableInputs.sortOrder : this.sortOrder ? this.sortOrder : '';
    this.showDropshipBeside = this.tableInputs.hasOwnProperty('showDropshipBeside') ? this.tableInputs.showDropshipBeside : '';
    this.showSort = this.tableInputs.hasOwnProperty('showSort') ? this.tableInputs.showSort : true;
    this.showFilter = this.tableInputs.hasOwnProperty('showFilter') ? this.tableInputs.showFilter : true;
    this.showPriorityBeside = this.tableInputs.hasOwnProperty('showPriorityBeside') ? this.tableInputs.showPriorityBeside : '';
    this.priorityKey = this.tableInputs.hasOwnProperty('priorityKey') ? this.tableInputs.priorityKey : '';
    this.resizeWidth = this.tableInputs.hasOwnProperty('resizeWidth') ? this.tableInputs.resizeWidth : false;
    this.resizeParameters = this.tableInputs.hasOwnProperty('resizeParameters') ? this.tableInputs.resizeParameters : {};
    this.rowTitleClass = this.tableInputs.hasOwnProperty('rowTitleClass') ? this.tableInputs.rowTitleClass : '';
    this.noSearchData = this.tableInputs.hasOwnProperty('noSearchData') ? this.tableInputs.noSearchData : true;
    this.showReason = this.tableInputs.hasOwnProperty('showReason') ? this.tableInputs.showReason : false;
    this.remarksMaxLength = this.tableInputs.hasOwnProperty('showReasonMaxLength') ? this.tableInputs.showReasonMaxLength : 2500;
    this.showNoMath = this.tableInputs.hasOwnProperty('showNoMath') ? this.tableInputs.showNoMath : false;
    this.showSuspend = this.tableInputs.hasOwnProperty('showSuspend') ? this.tableInputs.showSuspend : false;
    this.showNoDataFullScreen = this.tableInputs.hasOwnProperty('showNoDataFullScreen') ? this.tableInputs.showNoDataFullScreen : false;
    this.sortByOptions = this.tableInputs.sortByOptions;
    this.defaultSort = this.tableInputs.defaultSort;
    this._commonService.defaultSort = this.defaultSort;
    this.sortTableData();
    this.SelectedData = [];
    this.totalPrice = this._commonService.totalPrice;
    this.page = 0;
    this.numbersOnly = this.tableId === 'newPhysicalInventory' && this.tableId === 'createSpoilage' ? false : true;

    if (this.originalData !== undefined) {
      this.location = this.tableInputs.tableData.hasOwnProperty('locations') ? this.tableInputs.tableData.locations : [];
      this.tableData.forEach(element => {
        if (element.checked != null && element.checked === true) {
        this.SelectedData.push(element);
        }
      });
      const hasActiveFilter = Array.isArray(this.filterArray)
        && this.filterArray.some((f: any) => f?.innervalue?.some((x: any) => x.checked));
      // Keep search/filter chrome when a filter is active (e.g. Doc Type = Receiving with 0–1 rows)
      if (this.originalData.length < 2 && !this.tableInputs.searchApplied
        && !hasActiveFilter && !this._commonService.iconShow) {
        this.showSearch = false;
      } else if (this.tableInputs.hasOwnProperty('showSearch')) {
        this.showSearch = this.tableInputs.showSearch;
      }
      if (this.filterArray && Array.isArray(this.filterArray)) {
        this.filter = this.filterArray.map(value => ({ 'key': value.jsonKey, 'val': [] }));
        this.reservedFilter(this.filterArray);
        if (this._commonService.iconShow || hasActiveFilter) {
          this.showSearch = this.tableInputs.hasOwnProperty('showSearch') ? this.tableInputs.showSearch : true;
        }
      }
      this.getGetAllTableData(this.tableData);
      if (this.showHeader) {
        this.setTableWidth();
      }
      this.showNodata = !(this.originalData.length > 0);
      if ('duplicateElement' in changes) {
        if (this._duplicateElement) {
          this.scrollTo(this._duplicateElement, true);
        }
      }
      this.cdRef.detectChanges();
    }

    if (this._commonService.addQuantity) {
      this.tableData = this._commonService.itemListData;
      let editedItemIndex=-1;
      const isReqOrTransfer = (this.tableId === 'newRequisition' || this.tableId === 'newTransfers');
      if (isReqOrTransfer) {
        editedItemIndex = this.findReqTransferEditedItemIndex(this.tableData);
      } else {
        if(this._commonService?.editedItem?.hasOwnProperty("BinId")){
          editedItemIndex = this.tableData.findIndex(x => x?.BinId === this._commonService?.editedItem?.BinId);
       }
       if(editedItemIndex===-1 && this._commonService?.editedItem?.hasOwnProperty("LotId")){
        editedItemIndex = this.tableData.findIndex(x => x?.itemCode === this._commonService?.editedItem?.itemCode);
       }
       if(editedItemIndex===-1 && this._commonService?.editedItem?.BatchId){
        editedItemIndex = this.tableData.findIndex(x => x?.BatchId === this._commonService?.editedItem?.BatchId);
       }
       if(editedItemIndex===-1){
        editedItemIndex = this.tableData.findIndex(x => x?.id === this._commonService?.editedItem?.id);
       }
      }
      this.tableData[editedItemIndex]['oldQuantity'] = this._commonService.updatedQuantity;
      this.tableData[editedItemIndex].quantity = this._commonService.updatedQuantity;
      this.tableData[editedItemIndex].Fullquantity = this._commonService.updatedQuantity;
      this._commonService.itemListData[editedItemIndex]['oldQuantity'] = this._commonService.updatedQuantity;
      this._commonService.itemListData[editedItemIndex].quantity = this._commonService.updatedQuantity;
      this._commonService.itemListData[editedItemIndex].Fullquantity = this._commonService.updatedQuantity;
      if (this.tableData[editedItemIndex].addQuantity) {
        this.tableData[editedItemIndex].disableDetails = false;
      }
      this._commonService.addQuantity = false;
      this._commonService.itemListData[editedItemIndex].addQuantity = false;
      this._commonService.noMathHistory.subscribe(value => {
        let historyIndex=-1;
        if (isReqOrTransfer) {
          historyIndex = this.findReqTransferEditedItemIndex(this.tableData);
        } else {
          if(this._commonService?.editedItem?.hasOwnProperty("BinId")){
             historyIndex = this.tableData.findIndex(x => x?.BinId === this._commonService?.editedItem?.BinId);
          }
          if(historyIndex===-1 && this._commonService?.editedItem?.BatchId){
             historyIndex = this.tableData.findIndex(x => x?.BatchId === this._commonService?.editedItem?.BatchId);
          }
          if(historyIndex===-1 && this._commonService?.editedItem?.hasOwnProperty("itemCode")){
             historyIndex = this.tableData.findIndex(x => x?.itemCode === this._commonService?.editedItem?.itemCode);
          }
          if(historyIndex===-1){
             historyIndex = this.tableData.findIndex(x => x?.id === this._commonService?.editedItem?.id);
          }
        }
        this.tableData[historyIndex]['noMathHistory'] = value;
      });
      if(this.tableData[editedItemIndex]?.quantity > Number(this.tableData[editedItemIndex]?.BinCapacity)) {

        this.updateQuantity(this.tableData[editedItemIndex].quantity , this.tableData[editedItemIndex], editedItemIndex);
      }
      this.confirmUpdate(this._commonService.updatedQuantity,
                         this.tableData[editedItemIndex]);
      this.updateTableData.emit(this.tableData);
      if (this._commonService.itemListFilter && Array.isArray(this._commonService.itemListFilter)) {
        this.filter = this._commonService.itemListFilter.map(value => ({ 'key': value.jsonKey, 'val': [] }));
        this.reservedFilter(this._commonService.itemListFilter);
      }

     setTimeout(() => {
        this.virtualScroller?.scrollToIndex(editedItemIndex);
        // Added for if user views the last two records
        if ((editedItemIndex === (this.tableData.length - 1)) || (editedItemIndex === (this.tableData.length - 2)) ) {
          const scrollItem = document.getElementsByClassName('new-section')[0];
          if (scrollItem.scrollTop < 100) {
            scrollItem.scrollTop += scrollItem.scrollHeight;
          } else {
            scrollItem.scrollTop += 900;
          }
          }

      }, 100);
    }

    // Bug fix for 15303 and 15213
    if ((this._commonService.fromNoMath || this._commonService.fromDetailSection) && this._commonService.selectedIndex) {
      setTimeout(() => {
        const scrolledItem = document.getElementsByClassName('new-section')[0];
        this.virtualScroller.scrollToIndex(this._commonService.selectedIndex);
         // Added for if user views the last two records
        if ((this._commonService.selectedIndex === (this.tableData.length - 1)) ||
        (this._commonService.selectedIndex === (this.tableData.length - 2)) ) {
          scrolledItem.scrollTop += scrolledItem.scrollHeight;
          }
      }, 100);

    }
    setTimeout(() => {
      const tableBody = document.getElementsByClassName('table-body')[0] as HTMLElement;
      if (tableBody) {
        let minTableBodyHeight = 0;
        if (this.tableData.length >= 3) {
          minTableBodyHeight = 100 * (this.tableData.length === 0 ? 2 : 3);
        } else if (this.tableData.length === 2 || this.tableData.length === 1) {
          minTableBodyHeight = 100 * (this.tableData.length);
        } else if (this.tableData.length === 0) {
          minTableBodyHeight = 200
        }
        tableBody.style.setProperty('minHeight', minTableBodyHeight + 'px', 'important' )
      }
    }, 1);

    this.updateTableHeight(this.index);
  }

  openBottomSheet(Id:number): void {
    this.bottomSheet.emit(Id);
  }

  setTableWidth() {
    let overallgivenwidth = 0,
      ts;
    if (this.tableStyle) {
      const currTable = document.getElementById(this.tableId);
      for (ts = 0; ts < this.tableStyle.length; ts++) {
        if (currTable) {
          (<HTMLElement>currTable.getElementsByClassName('header-col')[ts])['style'].width = this.tableStyle[ts] + '%';
          const tableRow = currTable.getElementsByClassName('table-row');
          for (let tb = 0; tb < tableRow.length; tb++) {
            const bodyColumn = tableRow[tb].getElementsByClassName('body-col');
            for (let bc = 0; bc < bodyColumn.length; bc++) {
              if (bodyColumn[bc]) {
                (<HTMLElement>bodyColumn[bc]).style.width = this.tableStyle[bc] + '%';
              }
            }
          }
        }
        overallgivenwidth += Number(this.tableStyle[ts]);
      }
    }

  }

  getGetAllTableData(data) {
    if (data.length > 0) {
      this.tableColumn = Object.keys(data[0]);
      if (this.tableColumn[0] === 'checked') {
        this.tableColumn.splice(0, 1);
      }
      if (this.tableColumn.findIndex( x => x === 'statusText') > 0 ) {
        this.tableColumn.splice(this.tableColumn.findIndex( x => x === 'statusText'), 1);
      }
      if (this.tableColumn.findIndex( x => x === 'Fullquantity') > 0 ) {
        this.tableColumn.splice(this.tableColumn.findIndex( x => x === 'Fullquantity'), 1);
      }
      if (this.tableColumn.findIndex( x => x === 'docTypeId') > 0 ) {
        this.tableColumn.splice(this.tableColumn.findIndex( x => x === 'docTypeId'), 1);
      }
      ['approvalStatusId', 'LocationId', 'ToLocationId', 'FromLocId', 'fromLocationId', 'toLocationId'].forEach(field => {
        const id = this.tableColumn.findIndex(x => x === field);
        if (id > 0) { this.tableColumn.splice(id, 1); }
      });
    }
  }

  /******
   * @function reservedFilter()
   * @params Obj
   * @description Second level Emit Function from the Grand child
   */
  reservedFilter(receivedFilter) {
    if (this.tableSearch) {
      this.tableSearch.clearSearchValue();
    }
    let filterDatafrom = this.originalData;
    let isFirst = true;

    if (filterDatafrom) {
      receivedFilter.forEach(e => {
        const filterBy = e.jsonKey,
          filterDataBy = e.innervalue.filter(x => x.checked === true);
        if (filterDataBy.length > 0) {
          if (!isFirst) {
            filterDatafrom = this.customTableData;
          }
          const filteredData = [];
          if (this.tableId === 'recentTransfers' || this.tableId === 'offlineTransfers') {
            filterDataBy.forEach(element => {
              filterDatafrom.filter(x => {
                if (x[filterBy] === element.id) {
                  filteredData.push(x);
                }
              });

            });
          } else if (filterBy === 'dropShip') {
            filterDataBy.forEach(element => {
              filterDatafrom.filter(x => {
                if (x[filterBy] === element.filterValue) {
                  filteredData.push(x);
                }
              });

            });
          } else {
            filterDataBy.forEach(element => {
              filterDatafrom.filter(x => {
                if (element.id === null) {
                  if (x[filterBy] === null || x[filterBy] === '' || x[filterBy] === 'None') {
                    filteredData.push(x);
                  }
                } else if (x[filterBy] === element.value) {
                  filteredData.push(x);
                }
              });

            });
          }
          this.isCustomTableData = true;
          if (filterDataBy.length > 0 && isFirst) {
            this.customTableData = filteredData;
            isFirst = false;
          } else if (filterDataBy.length > 0 && !isFirst) {
            this.customTableData = filteredData;
          }

          const topItem = document.getElementsByClassName('table-row')[0];
          if (topItem && this._commonService.iconShow) {
            topItem.scrollIntoView(({ behavior: 'smooth', block: 'nearest', inline: 'start' }));
          }

        }

      });


      if (receivedFilter.filter(ele => ele.innervalue.every(x => x.checked === false)).length === this.filterArray.length) {
        this.isCustomTableData = false;
      }

      const data = this.isCustomTableData ? this.customTableData : this.originalData;
      if (data.length === 0) {
        this.showNodata = true;
      } else {
        this.showNodata = false;
      }

      this.searchData = this.isCustomTableData ? this.customTableData : this.originalData;
      this.sortData = this.isCustomTableData ? this.customTableData : this.originalData;
      this.tableData = this.isCustomTableData ? this.customTableData : this.originalData;

      this._commonService.iconShow = receivedFilter.filter(ele => ele.innervalue.some(x => x.checked === true)).length > 0;
      if (!this.locationChange) {
        this.getGetAllTableData(data);
      }
      // Fix for 15292
      this.sortTableData();
     // this.updateTableHeight(this.tableData.length);
      this.filterEmit.emit(this.searchData);
      this.filterValue.emit(this.filterArray);
    }
    this.updateTableHeight(-1);
  }

  applyFilter() {

  }

  /******
   * @function  clearData()()
   * @params Obj
   * @description Clear the all data
   */
  clearData() {
    if (this.filterArray.length !== 0) {
      this.filterArray.forEach(element => {
        element.innervalue.forEach(item => {
          item.checked = false;
        });
      });
      this.filter.forEach(element => {
        element.val = [];
      });
      this.tableData = [];
      this.tableData = this.originalData;
      this.searchData = this.tableData;
      if (this.tableData.length === 0) {
        this.showNodata = true;
      } else {
        this.showNodata = false;
      }
      this._commonService.iconShow = (this.indexArray.length > 0) ? true : false;
    }

  }

  /**
   * @method AfterviewData
   * @function ngAfterContentInit
   * @description Get scroll data emiter from the Service and Subcribe the Scroll Event;
   * @input Params None
   * @outPut triger the this.getScroll(data) method
   */
  ngAfterContentInit() {
    this.showButtonsFunction();
  }



  showButtonsFunction() {
    if (this.showQuantity || this.showAcknowledgementQty) {
      this.showButtons = false;
      this.totalDataBinded.emit(['', false]);
      if (this.originalData.length === this.tableData.length || this._commonService.iconShow) {
        this.showButtons = true;
        this.totalDataBinded.emit(['', true]);
      }
    }
  }
  /**
 * @method scroll event methd
 * @function getScroll(e?: any)
 * @param e optional paramater scroll @event
 * @description get body height and row height array push to one by one
 * @input params NONE
 * @output Array of object;
 */

  getScroll(e?: any) {

    if (!this.locationChange) {
      const bodyHeight = document.getElementById('app-container').clientHeight;
      const rowHeight = 100;
      const recordsPerCell = bodyHeight / rowHeight;
      const recordsCount = Math.ceil(recordsPerCell);
      this.countRecords = recordsCount + this.page;
      const data = this.isCustomTableData ? this.customTableData : this.originalData;
      if (data && data.length > 0) {
        data.slice(this.page, this.countRecords).forEach(element => {

          this.tableData.push(element);
          this.page++;
        });
        if (!(this.cdRef as ViewRef).destroyed) {
          this.cdRef.detectChanges();
          // do other tasks
        }

        if (!this.showQuantity && !this.showAcknowledgementQty) {
          if (this.tableData.length >= data.length) {
            this.showButtons = true;
            this.totalDataBinded.emit(['event', true]);
          } else {
            this.showButtons = true;
            this.totalDataBinded.emit(['event', false]);
          }
        }
      }

      this.tableData = [...this.tableData];
    }


  }

  nameClick(data: any, index: number): void {
    if (this.lengthCheck(index) || data.itemCollapse) {
      this.expand(data, index);
    }
  }

  lengthCheck(index: number): boolean {
    const containerElement = this.containers.toArray()[index]?.nativeElement;
    const namelengthElement = this.namelengths.toArray()[index]?.nativeElement;

    if (containerElement && namelengthElement) {
      return containerElement.scrollWidth < namelengthElement.offsetWidth;
    }
    return false;
  }
  ngAfterViewInit() {
    this.windowHeight = window.innerHeight;
    if (this.showHeader) {
      this.setTableWidth();
    }
    this.sortByOptions = this.tableInputs.sortByOptions;
    this.tableData = this.tableInputs.tableData;
    if(this.tableData.length > 0) {
      this.tableData.forEach((item, index) => {
        setTimeout(() => {
          this.nameClick(item,index);
        }, 30);
      });
    }
    if (this.filterData) {
      this.reservedFilter(this.filterData);
    }
    this.orderBy = this.tableInputs.hasOwnProperty('orderId') ? this.tableInputs.orderId : this.orderBy ? this.orderBy : '';
    this.sortOrder = this.tableInputs.hasOwnProperty('sortOrder') ? this.tableInputs.sortOrder : this.sortOrder ? this.sortOrder : 'desc';
    const bodyHeight = document.getElementById('app-container').clientHeight;
    const rowHeight = 100;
    const recordsPerCell = bodyHeight / rowHeight;
    const recordsCount = Math.ceil(recordsPerCell);
    this.countRecords = recordsCount + this.page;
    // Fix for 15210
    // if(this._commonService.fromDetailSection){
    //   this.tableData=this._commonService.itemListData;
    // }
    setTimeout(() => {
      const tableBody = document.getElementsByClassName('table-body')[0] as HTMLElement;
      let minTableBodyHeight = 0;
      if (this.tableData.length >= 3) {
        minTableBodyHeight = 100 * (this.tableData.length === 0 ? 2 : 3);
      } else if (this.tableData.length === 2 || this.tableData.length === 1) {
        minTableBodyHeight = 100 * (this.tableData.length);
      } else if (this.tableData.length === 0) {
        minTableBodyHeight = 200
      }
      tableBody.style.setProperty('minHeight', minTableBodyHeight + 'px', 'important' )
    }, 1);
  }

  toggleExpand(event, data, collapse, index?) {
    this.toggleSelectedIndex = collapse;
    this.expandedIndex = index;
    this.tableData.forEach(element => {
      element.collapse = true;
    });
    this.tableInputs.tableData.forEach(element => {
      element.collapse = true;
    });

    this.currentId = data.id;
    if (collapse) {
      data.collapse = false;
      this.tableInputs.tableData.filter(x => x.id === data.id).map(x => x.collapse = false);
    } else {
      data.collapse = true;
      this.tableInputs.tableData.filter(x => x.id === data.id).map(x => x.collapse = true);
    }
    this.IconBackClicked.emit([data, data.collapse]);
    if (collapse) {
      const viewPortHeight = this._commonService.viewPortHeight;
      const targetHeight = event.clientY;
      // Changed for bug fix 15272
      this.isBottom = Math.round((targetHeight / viewPortHeight) * 100) > 85;
      if (!this.isBottom) {
        this.isBottom = (this.tableData.length - 1) === this.expandedIndex ? true : false;
      }
      this.updateTableHeight(index);
      this.index = index;
    } else {
      this.isBottom = false;
      this.index = -1;
      this.updateTableHeight(this.index);
    }
  }

  RowSelect(event, SelectedRow, Frm, index?) {
    this.selectedIndex = index;
    if (Frm === 'All') {
      if (event.target.checked === true) {
        this.SelectedData = [];
        for (let l = 0; l < this.tableData.length; l++) {
          this.tableData[l].checked = event.target.checked;
          this.SelectedData.push(this.tableData[l]);
        }
      } else {
        this.SelectedData = _.difference(this.SelectedData, this.tableData);
      }
    } else {
      SelectedRow.checked = event.target.checked;
      if (this.SelectedData.indexOf(SelectedRow) === -1 && SelectedRow.checked) {
        this.tableInputs.tableData[index].checked = event.target.checked;
        this.SelectedData.push(SelectedRow);
      } else {
        this.tableInputs.tableData[index].checked = event.target.checked;
        this.SelectedData.splice(this.SelectedData.indexOf(SelectedRow), 1);
      }
      this.IsCheckAll = (_.difference(this.tableData, this.SelectedData).length === 0);
    }

    this.isSwipe = false;
    this.RowSelectEmitter.emit(this.SelectedData);
    this.CurrentRowSelectedEmitter.emit({ 'event': event, 'SelectedRow': SelectedRow, 'From': Frm });
  }

  updateQuantity = debounce((event: any, data: any, index: any) => {
    this._commonService.isFocusOut = false;
    if (data.addQuantity && !this._commonService.isBarcodeScan) {
      const dialogArray = {
      headerText: this._ts.instant('common.warning'),
      contentText: this._ts.instant('common.noMathConfirm'), cancelText: this._ts.instant('common.no'), confirmText: this._ts.instant('common.yes'),
        confirmHelpText: 'yes',
        cancelHelpText: 'no' };

      this._commonService.mobilePopUpProperty.data = dialogArray;
      const dialogRef = this.dialog.open(PopupComponent,
        this._commonService.mobilePopUpProperty
      );

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          switch (result.toLowerCase()) {
            case 'yes':  data.addQuantity = false;
            data.noMathHistory = []; data.disableDetails = true;
            this.confirmUpdate(event, data);
            break;
            case 'no': this.confirmUpdate(data.oldQuantity, data); break;
          }
        }
        // Bug id 15291 for focus issue in quantity field
        const focusedElement = <HTMLInputElement>document.getElementById('quantity-' + index);
        if (focusedElement.setSelectionRange) {
          focusedElement.setSelectionRange(data.quantity.toString().length, data.quantity.toString().length);
        }
      });
    } 
    else if(event < 0 && this.tableInputs.tableId !=='newTransfers' && this.tableInputs.tableId !=='newPurchase' && this.tableInputs.tableId !== 'createSpoilage'){      
      data.quantity = event;
      if(this.tableInputs.tableId === "newPhysicalInventory"){
        this.showPopUp(this._ts.instant('common.error'), this._ts.instant('physicalInventory.QuantityCannotBeNegative'), false, this._ts.instant('common.ok'),event, data);            
      }else{
        this.showPopUp(this._ts.instant('common.Info'), this._ts.instant('physicalInventory.ValueShouldBeGreaterThanZero'), false, this._ts.instant('common.ok'),event, data);            
      }
    }
    else if(event && this.tableInputs.tableId === 'newPhysicalInventory'){      
      data.quantity = event;
        const remainingCapacity = (this._commonService.cumulative && data.hasOwnProperty('BinId') && data.BinId) ? (parseFloat(data.BinCapacity?.toString()) - parseFloat(data.BinQOH?.toString())) : parseFloat(data.BinCapacity?.toString());

      if(data.hasOwnProperty('BinId') && data.BinId && (parseFloat(event) > remainingCapacity)) {
        const QtyInput = document.getElementById(`quantity-${index}`) as HTMLInputElement;
        this.showBinPopUp(this._ts.instant('common.Info'), this._ts.instant('physicalInventory.QuantityCannotGreaterThanBinCapacity'), false, this._ts.instant('common.ok'),event, data, QtyInput);    
      } if(data?.PurchaseQTY && (parseFloat(data.quantity?.toString())) > (parseFloat(data.PurchaseQTY))) {
        const QtyInput = document.getElementById(`quantity-${index}`) as HTMLInputElement;
        this.showBinPopUp(this._ts.instant('common.Info'), this._ts.instant('physicalInventory.BatchQtyMsg'), false, this._ts.instant('common.ok'),event, data, QtyInput);    
      } else {
        this.confirmBatchClearAndChangeQuantity(event, data, index);
      }
    }
    else {      
        this.confirmBatchClearAndChangeQuantity(event, data, index);
    }
  }, 300);

  calculateUnitCost (event:any, data:any, index:any) {
    data._showLongUnitCost = false;
    const unitcost = Number(event.target.value);
    data.cost = (unitcost.toFixed(4));
    data.calCost = data?.cost;
    this.confirmUpdate(data.quantity,data);
  }

  allocatedChargeschange(event:any, data:any) {
    const allocatedCharges = Number(event.target.value);
    data.AllocatedCharges = (allocatedCharges.toFixed(4));
    this.confirmUpdate(data.quantity,data);
  }

  showBinPopUp(headerText, contentText, cancelText, confirmText,event, data:any, qtyEvent: any) {
    const dialogArray = { headerText: headerText, contentText: contentText, cancelText: cancelText, confirmText: confirmText };
    this._commonService.mobilePopUpProperty.data = dialogArray;
    const dialogRef = this.dialog.open(PopupComponent,
      this._commonService.mobilePopUpProperty
    );

    dialogRef.afterClosed().subscribe((result) => {
        data.quantity = '';
        event = '';
        qtyEvent.value = '';
        this.confirmUpdate(event, data);
        this.cdRef.detectChanges();
      this._commonService.OpenProcessingPopUp('');
      this._commonService.closeProcessingPopUp();

    });
  }
  
  showPopUp(headerText, contentText, cancelText, confirmText,event, data:any) {
    const dialogArray = { headerText: headerText, contentText: contentText, cancelText: cancelText, confirmText: confirmText };
    this._commonService.mobilePopUpProperty.data = dialogArray;
    const dialogRef = this.dialog.open(PopupComponent,
      this._commonService.mobilePopUpProperty
    );

    dialogRef.afterClosed().subscribe((result) => {
      if(event.target.value < 0){
        data.quantity = '';
        this.cdRef.detectChanges();
      }
      this._commonService.OpenProcessingPopUp('');
      this._commonService.closeProcessingPopUp();
    });
  }

  confirmUpdate(event, data) {
    const _that = this;
    if (event != null ) {
      data.quantity = event; // ?Number(event).toFixed(2): event;
      _that._commonService.updatedQuantity = data.quantity;
      _that.negativeQuantity =  data.quantity < 0;
      if (_that.showTotalPrice) {
       let totalPrice = 0;
        switch (_that.tableId) {
          // case 'newRequisition':
          //   _that.tableData.forEach(element => {
          //     totalPrice = totalPrice + ((element.quantity === '' || !parseFloat(element.quantity) ? 0 :
          //     parseFloat(element.quantity)) * (element.cost === '' || !parseFloat(element.cost) ? 0 : element.cost));
          //   });
          //     break;
              
          case 'createSpoilage': 
            _that.tableData.forEach(element => {
            totalPrice = totalPrice + ((element.quantity === '' || !parseFloat(element.quantity) ? 0 :
            parseFloat(element.quantity)) * (element.cost === '' || !parseFloat(element.cost) ? 0 : element.cost));
          });
            break;

          case 'newPurchase': 
          _that.tableData.forEach(element => {
            totalPrice =  totalPrice + ((element.quantity.toString() === '' || !parseFloat(element.quantity.toString()) ? 0 :
              parseFloat(element.quantity)) * ((element.cost.toString() === '') ? 0 : parseFloat(element.cost.toString().replace(/[^0-9\.-]+/g,""))));
          });
          totalPrice += this._commonService.totalMiscCharges;
            break;
        }
        _that.totalPrice = totalPrice;
        this._commonService.totalPrice = this.totalPrice;
      }
      this.InputChange.emit(data);
    }
    setTimeout(function() { 
      _that.cdRef.detectChanges() }, 500);
  }

  rowClicked(event, data) {
    if (event.target.tagName.toLowerCase() !== 'input') {
      this.RowClicked.emit(data);
    }
  }

  nextIconClick(event, data) {
    if (event.target.tagName.toLowerCase() !== 'input') {
      this.IconNextClick.emit(data);
    }
  }

  receivedData(event) {
    this.showNodata = false;
    this.tableData = event;
    if (!event || event.length === 0) {
      this.showNodata = true;
    }
    this.updateTableHeight(-1);

  }

  clearSearch() {
    if (this._commonService.iconShow) {
      this.tableData = this.searchData;
    } else {
      this.tableData = this.originalData;
    }
    if (this.searchParms.SearchApplied === true) {
      this._commonService.searchValue = '';
      this.apiSearchemit.emit('');
    }
    this.searchData = this.tableData;
    this.showNodata = !(this.tableData.length > 0);
    this.updateTableHeight(-1);
  }

  moreOptionsClicked(event, name) {
    this.MoreOptionsClicked.emit([event, name]);
  }

  reasonChanged(event, data) {
    this.ReasonChange.emit([event, data]);
  }

  remarksChanged(event, data) {
    data.remarks = event;
    this.RemarksChange.emit([event, data]);
  }

  apiSearchOption(event) {
    event = event === '' ? 'fromClear' : event;
    this.apiSearchemit.emit(event);
  }

  onPanLeft(evt, data) {
    const popover = document.getElementsByClassName('popover')[0];
    if (popover) {
      popover['style'].display = 'none';
    }

    if (!data.disableQty && this.SelectedData.length < 1) {
      if (this.swipeDir === 'left') {
        this.swipeId = data.id === undefined ? data.DeviceId || data?.itemCode : data.id;
        this.isSwipe = true;
        if(data.hasOwnProperty("itemCode") && data.hasOwnProperty("LotNumber")){
          this.swipeId = data.itemCode === undefined ? data.DeviceId : data.itemCode;
          this.isSwipe = true;
        }
        if(data.hasOwnProperty("BinId") && data.hasOwnProperty("BinNumber")){
          this.swipeId = data.BinId === undefined ? data.DeviceId : data.BinId;
          this.isSwipe = true;
        }
        if(data.BatchId){
          this.swipeId = data.BatchId || data.DeviceId;
          this.isSwipe = true;
        }
        if (this.input) {
          this.input.target.blur();
        }
        if (this.remarkInput) {
          this.remarkInput.target.blur();
        }
      } else {
        if (this.isSwipe) {
          this.isSwipe = false;
          this.swipeId = '';
        }
      }
    }

  }

  toggleSwipe(event, data) {
    const popover = document.getElementsByClassName('popover')[0];
    if (popover) {
      popover['style'].display = 'none';
    }
    if (!data.disableQty && this.SelectedData.length < 1) {
      if (this.swipeDir === 'right') {
        this.swipeId = data.id === undefined ? data?.DeviceId || data?.itemCode : data.id;
        this.isSwipe = true;
        if(data.hasOwnProperty("itemCode") && data.hasOwnProperty("LotNumber")){
          this.swipeId = data.itemCode === undefined ? data.DeviceId : data.itemCode;
          this.isSwipe = true;
        }
        if(data.hasOwnProperty("BinId") && data.hasOwnProperty("BinNumber")){
          this.swipeId = data.BinId === undefined ? data.DeviceId : data.BinId;
          this.isSwipe = true;
        }
        if(data.BatchId){
          this.swipeId = data.BatchId || data.DeviceId;
          this.isSwipe = true;
        }
        if (this.input) {
          this.input.target.blur();
        }
        if (this.remarkInput) {
          this.remarkInput.target.blur();
        }
      } else {
        if (this.isSwipe) {
          this.isSwipe = false;
          this.swipeId = '';
        }
      }
 
    }
 
  }

  private findReqTransferEditedItemIndex(list: any[]): number {
    const edited = this._commonService?.editedItem;
    if (!edited || !Array.isArray(list)) {
      return -1;
    }
    if (edited.inventoryId != null) {
      const index = list.findIndex(x => x?.inventoryId === edited.inventoryId);
      if (index !== -1) {
        return index;
      }
    }
    if (edited.itemCode) {
      return list.findIndex(x => x?.itemCode === edited.itemCode);
    }
    return -1;
  }

  iconClick(event, type, data) {
    if (this.isSwipe) {
      this.isSwipe = false;
      this.swipeId = '';
    }
    this._commonService.selectedIndex = this.tableData.findIndex(x => x === data);
    switch (type) {
      case 'addQuantity':
        this._commonService.isBarcodeScan = false;
        this._commonService.editedItem = data;
        data['oldQuantity'] = data.quantity;
        data.addQuantity = true;
        this.invokeNoMath(data, type);
        break;

      case 'details':
        this._commonService.historyDetails = data;
        this._commonService.fromNoMath = true;
        this.invokeNoMath(data, type);
        break;
      case 'suspend':
        this.IconRowClick.emit([event, data]);
        break;
      default: this.IconRowClick.emit([this.swipeId, type, data]);
    }

  }

  invokeNoMath(data, type) {
    if (type === 'addQuantity') {
      const history = [];
    if (data.noMathHistory) {
      this._commonService.noMathHistory.next(data.noMathHistory);
    } else {
      this._commonService.noMathHistory.next(history);
    }
    this._commonService.itemListData = (this.tableId === 'newRequisition' || this.tableId === 'newTransfers') ? this.tableData : this.originalData;
    this._commonService.itemListFilter = this.filterArray;
    }
    this._commonService.addQuantity = true;

    this._commonService.routeStack.push(this.router.routerState.snapshot.url);
    const url = (type === 'addQuantity') ? ['/noMath'] : ['/historyDetails'];
    const queryParams = (type === 'addQuantity') ? { queryParams: { from: this.tableId } } : {};

    this.router.navigate(url, queryParams);
  }

  scrollTo(item, highlight?) {
      const _that = this;
      const itemindex = _that.tableData.findIndex(x => x.itemCode === item);
      _that._commonService.itemFocusIn = true;
      _that._commonService.selectedqtyIndex = itemindex;
      _that.virtualScroller?.scrollToIndex(itemindex);
      setTimeout(function() {        
        _that.scrollCallBackFunction(item, itemindex, highlight);
        if(_that._commonService.barcodeAutoIncrement !== "true" && this.deviceType === 'iOS') {
          const QtyInput = document.getElementById(`quantity-${itemindex}`) as HTMLInputElement;
          const isQtyFocus = this._CommonService?.quantityFocus ? this._CommonService.quantityFocus : window.localStorage.getItem('quantityFocus');
          if (QtyInput && _that._commonService.isBarcodeScan && isQtyFocus === 'true') {
            const QtyLength = QtyInput?.value?.length;
            QtyInput.focus();
            QtyInput.setSelectionRange(QtyLength, QtyLength);
            _that._commonService.isBarcodeScan = false;
          }
        }
      }, 200);


  }
  scrollCallBackFunction(item, itemindex, highlight?) {
    let addedItem;
    const allDivs = this._eR.nativeElement.querySelectorAll('.data-itemCode');
    const querySelectorAllArray = Array.prototype.slice.call(allDivs);
    querySelectorAllArray.forEach((element, index) => {
      if (element.innerText.trim().includes(item)) {
        addedItem =  this._eR.nativeElement.getElementsByClassName('table-row')[index];
      }
    });
  // let addedItem = this._eR.nativeElement.getElementsByClassName('table-row')[index];
  if (addedItem) {
    if (highlight) {
      // if scanned element in  last row need to set scroll top for the user to view the last row highlighted
      if (itemindex === (this.tableData.length - 1)) {
        const outerSection = document.getElementsByClassName('new-section')[0];
        if (outerSection.scrollTop < 100) {
          outerSection.scrollTop += 350;
        } else {
          outerSection.scrollTop += 150;
        }
      }
      if(this._commonService.isHighlightShow) {
        addedItem.classList.add('scrolled');
      }
      setTimeout(function () { addedItem.classList.remove('scrolled'); this._duplicateElement = ''; }, 2000);

    }

  }
  const RowCount = 5;
  if (itemindex < RowCount) {
    const scrollElement = document.getElementsByClassName('new-section')[0];
    scrollElement.scrollTop = 0;
  }
  }
  sortTable(event) {
    this.isSwipe = false;
    this.orderBy = event[1];
    this.sortOrder = event[0];
    this.sortType = event[2];
    this.sortEmit.emit(event);
    this.sortTableData();
  }

  sortTableData() {
    try {
      if (!this.tableData?.length) {
        return;
      }
      if (typeof this.tableData[0][this.orderBy] === 'number' || this.sortType === 'number') {
        this.tableData.sort((a, b) => {
          const data1 = Number(a[this.orderBy] ?? 0);
          const data2 = Number(b[this.orderBy] ?? 0);
          if (this.sortOrder === 'desc') {
              return data2 - data1;
          } else {
              return data1 - data2;
          }
      });
      this.tableData = [...this.tableData];
      } else {
        const getSortValue = (value: any) => (value ?? '').toString().toLowerCase();
        if ( this.sortOrder === 'aesc') {
          this.tableData.sort((a, b) =>  -(getSortValue(a[this.orderBy]) < getSortValue(b[this.orderBy])) ||
          + (getSortValue(a[this.orderBy]) !== getSortValue(b[this.orderBy])));
          this.tableData = [...this.tableData];
        } else if (this.sortOrder === 'desc') {
          this.tableData.sort((a, b) => -(getSortValue(a[this.orderBy]) > getSortValue(b[this.orderBy])) ||
          +(getSortValue(a[this.orderBy]) !== getSortValue(b[this.orderBy])));
          this.tableData = [...this.tableData];
        }
      }

      // Do not uncomment. If required contact UI team. Fix for navigation from noMath while applying filter
      // this.tableInputs.tableData = this.tableData;
      return;
    } catch (Error) {

    }
     }

  clickFilter(event) {
    this.checkStatusToFilter.emit(event);
  }

  clickSort(event) {
    this.checkStatusToSort.emit(event);
  }
  emitOffineNodataforSearch() {
    this.emitOffineforSearch.emit();
  }

  hideButtons(event, enable) {
    this.showButtons = enable;
    this.totalDataBinded.emit([event, enable]);
  }

  validateAcknowledgementQty(event, data, index) {
    data._showLongAck = false;
    this._commonService.itemFocusIn = false;
    this._commonService.isFocusOut = true;
    const previousAckQty = data.AcknowledgementQty;
    const rawValue = event?.target?.value;

    const upTargetValue = rawValue?.indexOf('.');
    const currentfieldLength = rawValue?.length;
    if (upTargetValue === -1 && currentfieldLength > this._commonService.allowNoOfNumericDigitsInField) {
      event.target.value = rawValue.substring(0, 10);
    }
    this.mathRandom = Math.random();

    const trfQty = parseFloat(data.quantity?.toString() ?? '0');
    const ackQty = rawValue !== '' && rawValue !== null && rawValue !== undefined
      ? parseFloat(rawValue.toString().split(',').join('')) : null;

    const min = trfQty >= 0 ? 0 : trfQty;
    const max = trfQty >= 0 ? trfQty : 0;
    const isInvalid = ackQty === null || isNaN(ackQty);
    const isOutOfRange = !isInvalid && (ackQty < min || ackQty > max);

    if (isInvalid || isOutOfRange) {
      const popUpContent = isInvalid
        ? this._ts.instant('common.AckQtyRequired')
        : `${this._ts.instant('common.AckQtyRange')} ${min} - ${max}`;
      const dialogArray = {
        headerText: this._ts.instant('common.ValidationFailed'),
        contentText: popUpContent,
        cancelText: false,
        confirmText: this._ts.instant('common.ok')
      };
      this._commonService.mobilePopUpProperty.data = dialogArray;
      const dialogRef = this.dialog.open(PopupComponent, this._commonService.mobilePopUpProperty);
      dialogRef.afterClosed().subscribe(() => {
        data.AcknowledgementQty = previousAckQty;
        const inputEl = document.getElementById(`AcknowledgementQty-${index}`) as HTMLInputElement;
        if (inputEl) { inputEl.value = previousAckQty != null ? String(previousAckQty) : ''; }
        this.cdRef.detectChanges();
        this._commonService.OpenProcessingPopUp('');
        this._commonService.closeProcessingPopUp();
      });
      return;
    }

    data.AcknowledgementQty = ackQty;
    event.target.value = parseFloat(ackQty.toFixed(this._commonService.decimalFocusinLength));
    this.InputChange.emit(data);
  }
  validateQuantity(event, data, index) {
    data._showLong = false;
    this._commonService.itemFocusIn =  false;
    this._commonService.isFocusOut =true;
    const upTargetValue = (event.target.value).indexOf('.');
    const currentfieldLength = event.target.value.length;
      if (upTargetValue == -1 && currentfieldLength > this._commonService.allowNoOfNumericDigitsInField) {
        event.target.value = event.target.value.substring(0, 10);
      }
    this.mathRandom = Math.random();
    const decimalPoint = this._commonService.decimalFocusinLength;
    const x = isNaN(parseFloat(event.target.value.toString().split(',').join(''))) ? '' :
              parseFloat(event.target.value.toString().split(',').join('')).toFixed(decimalPoint);
    if(event.target.value < 0 && this.tableInputs.tableId !=='newTransfers'){      
      return;
    }
  this.confirmUpdate(event.target.value, data);
    if (index === this.tableData?.length -1 && this.tableInputs.tableId === 'newPhysicalInventory') {
      event.target.blur();
      this._commonService.selectedqtyIndex = 0;
    }
  }

  confirmBatchClearAndChangeQuantity(currentQty: any, data: any, index?: number) {
    const previousQty = data.quantity;

    let hasChanged = false;
    if (currentQty === null || previousQty === null) {
      hasChanged = String(currentQty) !== String(previousQty);
    } else {
      hasChanged = currentQty !== previousQty;
    }
    if (data?.ConsignmentBatch?.length > 0 && hasChanged) {
      const dialogArray = {
        headerText: this._ts.instant('common.warning'),
        contentText: this._ts.instant('common.ConsignmentWarningQty'),
        cancelText: this._ts.instant('common.no'),
        confirmText: this._ts.instant('common.yes'),
        confirmHelpText: 'yes',
        cancelHelpText: 'no'
      };
      this._commonService.mobilePopUpProperty.data = dialogArray;
      const dialogRef = this.dialog.open(PopupComponent, this._commonService.mobilePopUpProperty);
      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'yes') {
          data.ConsignmentBatch = [];
          this.confirmUpdate(currentQty, data);
        } else {
          data.quantity = previousQty;
          if (index !== undefined) {
            const el = document.getElementById(`quantity-${index}`) as HTMLInputElement;
            if (el) { el.value = data.quantity; }
          }
          this.cdRef.detectChanges();
        }
      });
    } else {
      this.confirmUpdate(currentQty, data);
    }
  }

  scrollUp(event) {
    this.input = event;
    event.target.closest('.table-row').scrollIntoView(({ behavior: 'smooth', inline: 'end' }));
    event.stopPropagation();
  }

  focusedInput(event, index, data) {
    data._showLong = true
    this.input = event;
    this.inputIndex = index;
    this._commonService.selectedqtyIndex = index;
  }
  focusedAckInput(event, index, data) {
    data._showLongAck = true
    this.input = event;
    this.inputIndex = index;
  }
  focus(event) {
    this.remarkInput = event;
    event.stopPropagation();
  }
  updateTableHeight(index?) {
    // debugger;
    // const defaultRowHeight = 83;
    // let _this = this;
    // setTimeout(() => {
    //   if(document.getElementsByClassName('collapse')[0]) {
    //   const titleHeight = document.querySelector('.title-view') ? document.querySelector('.title-view').clientHeight : 0;
    //   const addSearchHeight = document.querySelector('.add-item') ? document.querySelector('.add-item').clientHeight : 0;
    //   const requestButtonHeight = document.querySelector('.request-details-mobile') ?
    //                               document.querySelector('.request-details-mobile').clientHeight : 0;
    //   const itemSummaryHeight = document.querySelector('.item-summary') ? document.querySelector('.item-summary').clientHeight : 0;
    //   const overallHeight = window.innerHeight - (titleHeight + addSearchHeight + requestButtonHeight + itemSummaryHeight);
    //   // const isTableRowAvaiable = ;
    //   const collapseHeight = document.getElementsByClassName('collapse')[0] ?
    //   document.getElementsByClassName('collapse')[0]['clientHeight'] : 0;
    //   const rowHeight =  document.getElementsByClassName('table-row')[0] ?
      //  document.getElementsByClassName('table-row')[0]['offsetHeight']: defaultRowHeight;
    //   const totalRowCount = rowCount ? rowCount : this.tableData.length;
    //   const allRowsHeight = rowHeight * totalRowCount;
    //   const isCollapseAvailable = _this.tableData.filter(x => x.collapse === false);
    //   const isCollapse = isCollapseAvailable ? isCollapseAvailable.length : 0;
    //   if (allRowsHeight > overallHeight) {
    //      document.getElementsByClassName('table-body')[0]['style'].height = isCollapse > 0 ? `${overallHeight}px` : `${overallHeight}px`;
    //   } else {
    //     document.getElementsByClassName('table-body')[0]['style'].height = isCollapse > 0 ? `${allRowsHeight + 117}px` :
    //     (collapseHeight > 0 ? `${collapseHeight * rowCount}px` : `${allRowsHeight}px`);
    //   }
    //   if (this.scrollOffSetHeight) {
    //     this.viewport1.scrollToOffset(this.scrollOffSetHeight, 'auto');
    //   }
    // }
    // }, 5);
    const _this = this;
    this.searchFilteredTableData.emit(_this.tableData);
    if (this.intial) {
      setTimeout(() => {
      _this.rowHeight = document.getElementsByClassName('table-row').length > 0 ? document.getElementsByClassName('table-row')[0]['offsetHeight'] : 0;
      _this.intial = false;
      }, 20);
    }
    this.toggleSelectedIndex = this.originalData.some(x => x.collapse === false);
    const windowHeight =  window.innerHeight;
    const title = document.getElementsByClassName('title-view').length > 0 ?
    document.getElementsByClassName('title-view')[0]['offsetHeight'] : 0;
    const addItem = document.getElementsByClassName('add-item').length > 0 ?
    document.getElementsByClassName('add-item')[0]['offsetHeight'] : 0;
    const itemSummary = document.getElementsByClassName('item-summary').length > 0 ?
    document.getElementsByClassName('item-summary')[0]['offsetHeight'] : 0;
    const itemListTitle = document.getElementsByClassName('item-list-title').length > 0 ?
    document.getElementsByClassName('item-list-title')[0]['offsetHeight']  : 0;
    const customSearch = document.getElementsByClassName('custom-search-tab').length > 0 ?
    document.getElementsByClassName('custom-search-tab')[0]['offsetHeight']  : 0;
    const remainingHeight = windowHeight - (title + addItem + itemSummary + itemListTitle + customSearch + 20);

     setTimeout(() => {
      let expandedHeight;

      if (index !== -1 ) {
        _this.selectedRowIndex = index;
        _this.expandedHeight = document.getElementById('app-table-row-' + index).offsetHeight - _this.rowHeight;
      } else {
        expandedHeight = 0;
      }
      const rowCount = _this.tableData.length;
      const defaultRowCount = 5;
      _this.index = -1;
      let actualRowHeight = _this.rowHeight * rowCount ;
      const defaultHeight = _this.rowHeight * (rowCount < defaultRowCount ? rowCount : defaultRowCount);
      if (actualRowHeight < remainingHeight) {
        actualRowHeight = this.toggleSelectedIndex  ? (actualRowHeight +  _this.expandedHeight) : actualRowHeight;

        document.getElementById('app-table-body').style.height = actualRowHeight + 'px';
      } else {
        if (remainingHeight > defaultHeight) {
        document.getElementById('app-table-body').style.height = remainingHeight  + 'px';
        } else {
        document.getElementById('app-table-body').style.height = defaultHeight + 'px';
        }
      }
      if( _this.tableId === 'newRequisition') {
        if(!_this.tableData.length){
          document.getElementById('app-table-body').style.height = '400px';
        }
        document.getElementById('app-table-body').style.maxHeight = '1000px';
      }
      // Fix for Bug 15272
      if (this.isBottom) {
        this.disableDataAppend = true;
        const addedItem = document.getElementsByClassName('new-section')[0];
        if (addedItem.scrollTop < 100) {
          addedItem.scrollTop += 350;
        } else {
          addedItem.scrollTop += 150;
        }
        const selectedItem =  this._eR.nativeElement.getElementsByClassName('table-row')[this.expandedIndex];
        if (selectedItem) {
          selectedItem.scrollIntoView(({ behavior: 'auto' }));
        }
      }
      const selectedItem =  this._eR.nativeElement.getElementsByClassName('table-row')[this.expandedIndex];
        if (selectedItem) {
          selectedItem.scrollTop = 0;
        }
     }, 50);
  }

  onContentScrolled(data: CdkScrollable) {
  //  this.scrollOffSetHeight = this.viewport1.measureScrollOffset('top');
  }

    expand(data, index) {
        data.itemCollapse = !data.itemCollapse;
        if(this.tableId === 'createSpoilage') {
          setTimeout(() => {
            this.adjustRemarksMargin(data.itemCollapse, index, data);
          }, 50);
        } else if (this.tableId === 'physicalDetails') {
          setTimeout(() => {
            this.adjustLotNumber(data.itemCollapse, index);
          }, 50)
        }
    }

    adjustRemarksMargin(itemCollapse: boolean, index: number, data?:any): void {
      const itemNameSpan = document.getElementsByClassName('data-itemName')[index];
      const remarksFieldElement = this.remarksField.toArray()[index]?.nativeElement;
    
      if (itemNameSpan && remarksFieldElement) {
        const itemNameHeight = itemNameSpan['offsetHeight'];
        const newTopValue = itemCollapse
          ? itemNameHeight + 30 + 'px' // Collapsed state margin
          : itemNameHeight + 45 + 'px'; // Expanded state margin
        remarksFieldElement.style.top = data?.isConsignment ? 90 + 'px' : newTopValue;
        remarksFieldElement.style.setProperty('top', remarksFieldElement.style.top, 'important');
      }
    }

    adjustLotNumber(itemCollapse, index) {
      const tableRow = document.getElementById(`app-table-row-${index}`);
      const lotNumberElement = tableRow.getElementsByClassName('data-lotNumber')[0] as HTMLElement;
      if (lotNumberElement) {
        lotNumberElement.style.top = itemCollapse ? '-40px' : '-55px';
      }
    }

    onScroll(event: any) {
      const scrollTop = event.target.scrollTop;  // current scroll position
      const scrollHeight = event.target.scrollHeight;  // total scrollable height
      const clientHeight = event.target.clientHeight;  // visible area height
  
      if (scrollTop + clientHeight >= scrollHeight) {
        const totalTableCount = this.tableInputs?.totalCount;
        if (this.tableInputs.tableData.length < totalTableCount) {
          this.tableInputs.bottomReached(this.tableData.length);
        }
      }
    }

    onScrolledIndexChange(event: any) {
      if (event !== 0) {
        this.scrollIndexChange.emit(event);
      }
    }

    showErrorInfo(event,error) {
      const contentText = Object.entries(error)
        .map(([key, value]) => `${value}`)
        .join('<br>');
      const dialogArray = {
        headerText: this._ts.instant("common.Info"), contentText: contentText, cancelText: null,
        confirmText: this._ts.instant("common.ok"), confirmHelpText: this._ts.instant("common.ok")
      };
      this._commonService.mobilePopUpProperty.data = dialogArray;
      const dialogRef = this.dialog.open(PopupComponent,
        this._commonService.mobilePopUpProperty
      );
      event?.preventDefault();
      event?.stopPropagation();
    }

    ngOnDestroy() {
      this.cdRef.detach();
      this._commonService.fromDetailSection = false;
      this.tableData.forEach(element => {
        element.collapse = true;
      });
      this.tableInputs.tableData.forEach(element => {
        element.collapse = true;
      });
      this._commonService.fromNoMath = false;
      this._commonService.fromDetailSection = false;
  
    }
}
